// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__FTQ2j","loader":"Loader_loader__qgKls","dot":"Loader_dot__7fpV4","movement":"Loader_movement__iPZYr","size-opacity":"Loader_size-opacity__JM_qw"};